const USER_ID_INJECTION_EXCLUDED_APIS = new Set([
  "huyauserui.getUserProfile",
  "webLiveUI.reportUserGameToolUsage",
]);

export function shouldInjectUserId(moduleName: string, funcName: string): boolean {
  return !USER_ID_INJECTION_EXCLUDED_APIS.has(`${moduleName}.${funcName}`);
}
